import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Field, Select, Skeleton } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { getIapPollInfo } from '~/components/molecules/IapPollListItem/getIapPollInfo';
import { useIapPollsQuery } from '~/lib/api/modules/IapPolls/hooks/useIapPollsQuery';

export type IIapPollSelectorProps = IOmit<ISelectProps, 'items'> & {
  appId: string;
};

export const IapPollSelector = forwardRef<
  HTMLInputElement,
  IIapPollSelectorProps
>(function IapPollSelector(props, forwardedRef) {
  const { appId, ...other } = props;
  const iapPollsQuery = useIapPollsQuery({ appId });
  const { t } = useTranslation();
  const items: Array<IFilterableListItem> =
    iapPollsQuery.data?.items.map((iapPoll) => {
      const iapPollInfo = getIapPollInfo(iapPoll);

      return {
        value: iapPoll._id,
        label: iapPoll.title,
        trailingSupportingText: t(`IapPollInfo.${iapPollInfo.status}`),
      };
    }) ?? [];

  return iapPollsQuery.isError ? (
    <ErrorMessage error={iapPollsQuery.error} />
  ) : !!iapPollsQuery.data || !iapPollsQuery.isLoading ? (
    <Select
      {...other}
      items={items}
      ref={forwardedRef}
      disabled={iapPollsQuery.isLoading}
    />
  ) : (
    <Skeleton>
      <Field />
    </Skeleton>
  );
});
